import classNames from 'classnames';
import PropTypes from 'prop-types';

const TextFirstlineLeftIcon = ({ className }) => {
  const iconClassName = classNames('text-firstline-left', className);

  return (
    <svg className={iconClassName} fill='none' width='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5'>
        <path d='m3 3.5h6' opacity='0.4' />
        <path d='m3 9.5h6' opacity='0.4' />
        <path d='m3 15.5h18' />
        <path d='m3 21.5h18' />
        <path d='m13.5858 9.91421c.5858.58579 1.5286.58579 3.4142.58579s2.8284 0 3.4142-.58579c.5858-.58578.5858-1.52859.5858-3.41421s0-2.82843-.5858-3.41421c-.5858-.58579-1.5286-.58579-3.4142-.58579s-2.8284 0-3.4142.58579c-.5858.58578-.5858 1.52859-.5858 3.41421s0 2.82843.5858 3.41421z' />
      </g>
    </svg>
  );
};

TextFirstlineLeftIcon.propTypes = {
  className: PropTypes.string,
};

export default TextFirstlineLeftIcon;
